import { createPolarClientPlugin } from "@beztack/payments-polar/auth-client";
import { adminClient, organizationClient, twoFactorClient } from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import { env } from "@/env";

export const authClient = createAuthClient({
  /** The base URL of the server (optional if you're using the same domain) */
  baseURL: env.VITE_API_URL,
  fetchOptions: {
    credentials: "include",
  },
  plugins: [
    twoFactorClient(),
    adminClient(),
    organizationClient({
      teams: {
        enabled: true,
      },
      schema: {
        organization: {
          additionalFields: {
            businessType: {
              type: "string",
              required: true,
              fieldName: "businessType",
              input: true,
            },
          },
        },
      },
    }),
    ...(env.VITE_PAYMENT_PROVIDER === "polar" ? [createPolarClientPlugin()] : []),
  ],
});
